import { CountriesResponse } from "client/types";
import { fetchApiData } from "client/utils/fetchApiData";

export default (): Promise<CountriesResponse> => {
  return fetchApiData({
    url: `/api/user/countries/?ordering=name`,
  });
};
